<div class="shell">
  <aside class="sidebar">
    <div class="brand">
      <span class="brand-mark">R</span>
      <div>
        <div class="brand-name">Rentwize</div>
        <div class="brand-sub">Admin Portal</div>
      </div>
    </div>

    <nav class="nav">
      <a routerLink="/dashboard" routerLinkActive="active">Dashboard</a>
      <a routerLink="/users" routerLinkActive="active">Users</a>
      <a routerLink="/rent-payments" routerLinkActive="active">Rent Payments</a>
      <a routerLink="/transactions" routerLinkActive="active">Transactions</a>
      <a routerLink="/points" routerLinkActive="active">Points</a>
      <a routerLink="/tillo-brands" routerLinkActive="active">Tillo Brands</a>
      <a routerLink="/shopping-partner-categories" routerLinkActive="active">Partner Categories</a>
      <a routerLink="/shopping-partners" routerLinkActive="active">Shopping Partners</a>
      <a routerLink="/shopping-partner-rewards" routerLinkActive="active">Partner Rewards CSV</a>
      <a routerLink="/agencies" routerLinkActive="active">Agencies</a>
      <a routerLink="/media-library" routerLinkActive="active">Media Library</a>
      <a routerLink="/notifications" routerLinkActive="active">Offers &amp; Campaigns</a>
      <a routerLink="/card-programs" routerLinkActive="active">Card Programs</a>
      <a routerLink="/subscriptions" routerLinkActive="active">Subscriptions</a>
      <a routerLink="/webhook-logs" routerLinkActive="active">Webhook Logs</a>
      <a routerLink="/support-tickets" routerLinkActive="active">Support Tickets</a>
      <a routerLink="/kobble" routerLinkActive="active">Kobble</a>
      <a routerLink="/settings" routerLinkActive="active">Configuration</a>
    </nav>

    <div class="sidebar-foot">
      @if (auth.admin(); as admin) {
        <div class="admin-meta">
          <div class="admin-name">
            {{ admin.first_name || 'Admin' }} {{ admin.last_name || '' }}
          </div>
          <div class="admin-email">{{ admin.email }}</div>
        </div>
      }
      <button type="button" class="btn btn-ghost btn-block" (click)="logout()">Logout</button>
    </div>
  </aside>

  <div class="main">
    <header class="topbar">
      <div class="topbar-title">Rentwize Operations</div>
    </header>
    <main class="content">
      <router-outlet />
    </main>
  </div>
</div>
